export default __webpack_public_path__ + "static/media/postSuvinil9.c24f5ef6.png";